/**
 * Reads the current text selection inside a container element.
 * Returns normalized multi-word text or null for collapsed / invalid selections.
 */
export function readMultiWordSelection(container: HTMLElement): { text: string; rect: DOMRect } | null {
  const selection = window.getSelection()
  if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
    return null
  }

  const range = selection.getRangeAt(0)
  if (!container.contains(range.commonAncestorContainer)) {
    return null
  }

  const raw = selection.toString().replace(/\s+/g, ' ').trim()
  if (!raw.includes(' ') || raw.length < 3) {
    return null
  }

  if (!/^[A-Za-z]+(?:[-'][A-Za-z]+)*(?:\s+[A-Za-z]+(?:[-'][A-Za-z]+)*)+$/.test(raw)) {
    return null
  }

  return { text: raw, rect: range.getBoundingClientRect() }
}
